var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yszck"},[_c('div',{staticClass:"fhan",on:{"click":function($event){return _vm.gosy()}}},[_vm._v("返回")]),_c('div',{staticClass:"nrk",domProps:{"innerHTML":_vm._s(_vm.nr)}})])}
var staticRenderFns = []

export { render, staticRenderFns }